export const SELECT_SHIPPING_PRICES = {
  US: [
    { weight: 0.1, price: 16 },
    { weight: 0.25, price: 19 },
    { weight: 0.5, price: 25 },
    { weight: 0.75, price: 30 },
    { weight: 1, price: 38 },
    { weight: 1.25, price: 43 },
    { weight: 1.5, price: 47 },
    { weight: 1.75, price: 52 },
    { weight: 2, price: 56 },
    { weight: 2.25, price: 62 },
    { weight: 2.5, price: 68 },
    { weight: 2.75, price: 74 },
    { weight: 3, price: 79 },
  ],
};

export const getSelectShippingMinMaxWeightForCountry = (country) => {
  const prices = SELECT_SHIPPING_PRICES[country];
  if (!prices || prices.length < 1) return null;

  const minWeight = Math.min(...prices.map((price) => price.weight));
  const maxWeight = Math.max(...prices.map((price) => price.weight));
  return { minWeight, maxWeight };
};
